(() => {
  'use strict';

  const ELEMENT_NAME = 's-hospital-cage-card-generator';
  if (customElements.get(ELEMENT_NAME)) return;

  class HospitalCageCardGenerator extends HTMLElement {
    connectedCallback() {
      if (this.__hospitalCageCardInitialised) return;
      this.__hospitalCageCardInitialised = true;



  var root=this;
  var $=function(id){return root.querySelector("#"+id)};
  var LB_PER_KG=2.20462;
  var state={
    segSpecies:"dog",
    segDesexed:null,
    segWU:"kg",
    segCode:null,
    segBeh:null,
    segBarrier:null,
    segImm:null,
    segInf:null,
    segChemo:null,
    segSz:null,
    segDiet:null
  };
  var currentWeightUnit="kg";
  var printMarker=null;
  var printCleanupTimer=null;
  var printRestorePending=false;
  var printMediaQuery=null;
  var MM_TO_PX=96/25.4;
  var PRINT_SPECS={
    a5l:{label:"A5 landscape",widthMm:210,heightMm:148,marginMm:7},
    a4p:{label:"A4 portrait",widthMm:210,heightMm:297,marginMm:9},
    a4l:{label:"A4 landscape",widthMm:297,heightMm:210,marginMm:9}
  };

  function pad2(n){return n<10?"0"+n:String(n)}
  function text(id,value){$(id).textContent=value||"—"}
  function clean(id){return String($(id).value||"").trim()}
  function fmt(n){
    if(typeof n!=="number"||!isFinite(n))return "—";
    if(Math.abs(n)>=1000)return Math.round(n).toLocaleString("en");
    return parseFloat(n.toPrecision(4)).toString();
  }
  function todayValue(){
    var d=new Date();
    return d.getFullYear()+"-"+pad2(d.getMonth()+1)+"-"+pad2(d.getDate());
  }
  function displayDate(value){
    if(!/^\d{4}-\d{2}-\d{2}$/.test(value))return value||"—";
    var bits=value.split("-");
    return bits[2]+"/"+bits[1]+"/"+bits[0];
  }
  function hasWeightEntry(){return clean("iWeight")!==""}
  function hasSpecialDiet(){return state.segDiet==="Yes"||!!clean("iDietText")}
  function getWeightKg(){
    var raw=Number($("iWeight").value);
    if(!isFinite(raw)||raw<=0)return null;
    return state.segWU==="lb"?raw/LB_PER_KG:raw;
  }
  function weightText(){
    var kg=getWeightKg();
    if(!kg)return "—";
    return fmt(kg)+" kg / "+fmt(kg*LB_PER_KG)+" lb";
  }
  function rerValue(){
    var kg=getWeightKg();
    return kg?70*Math.pow(kg,.75):null;
  }
  function initSegment(id,options){
    var wrap=$(id);
    options=options||{};
    Array.prototype.forEach.call(wrap.querySelectorAll("button"),function(button){
      button.addEventListener("click",function(){
        var key=id;
        var value=button.getAttribute("data-value");
        var wasPressed=button.getAttribute("aria-pressed")==="true";
        Array.prototype.forEach.call(wrap.querySelectorAll("button"),function(item){item.setAttribute("aria-pressed","false")});
        if(options.allowClear&&wasPressed){
          state[key]=null;
        }else{
          button.setAttribute("aria-pressed","true");
          state[key]=value;
        }
        clearTransientNotice();
        if(typeof options.change==="function")options.change(state[key]);
        render();
      });
    });
  }
  function resetSegment(id,value){
    var wrap=$(id);
    Array.prototype.forEach.call(wrap.querySelectorAll("button"),function(button){
      button.setAttribute("aria-pressed",button.getAttribute("data-value")===value?"true":"false");
    });
    state[id]=value;
  }
  function setNotice(kind,message){
    var box=$("formNotice");
    box.className="notice"+(message?" show "+kind:"");
    box.textContent=message||"";
  }
  var FLAG_EMOJIS={barrier:"🧤",immune:"🛡️",infectious:"☣️",cytotoxic:"🧪",seizure:"⚡",diet:"🍽️",npo:"🚫"};
  var BEHAVIOUR_EMOJIS={Calm:"🙂",Anxious:"😟",Aggressive:"⚠️"};
  function addChip(container,kind,label,icon){
    var chip=document.createElement("span");
    chip.className="alert-chip "+kind;
    if(icon){
      var emoji=document.createElement("span");
      emoji.className="chip-emoji";
      emoji.setAttribute("aria-hidden","true");
      emoji.textContent=icon;
      chip.appendChild(emoji);
    }
    var labelText=document.createElement("span");
    labelText.textContent=label;
    chip.appendChild(labelText);
    container.appendChild(chip);
  }
  function renderWeight(){
    var kg=getWeightKg();
    var calc=$("weightCalc");
    if(!kg){
      calc.textContent="Enter the body weight to show the kg/lb conversion and resting energy requirement.";
      return;
    }
    calc.textContent=weightText()+" · RER "+fmt(rerValue())+" kcal/day · Working: 70 × "+fmt(kg)+" kg^0.75";
  }
  function renderAlerts(){
    var wrap=$("pAlerts");
    wrap.innerHTML="";
    var count=0;
    function chip(kind,label,icon){addChip(wrap,kind,label,icon);count++}
    if(state.segBarrier==="Full PPE")chip("barrier","Barrier: full PPE",FLAG_EMOJIS.barrier);
    else if(state.segBarrier==="Gloves")chip("barrier","Barrier: gloves",FLAG_EMOJIS.barrier);
    if(state.segImm==="Yes")chip("immune","Immunocompromised",FLAG_EMOJIS.immune);
    if(state.segInf==="Yes")chip("infectious","Infectious: isolate",FLAG_EMOJIS.infectious);
    if(state.segInf==="Yes"&&(state.segBarrier===null||state.segBarrier==="None"))chip("amber","Barrier level not set",FLAG_EMOJIS.barrier);
    if(state.segChemo==="Yes")chip("cytotoxic","Cytotoxic precautions",FLAG_EMOJIS.cytotoxic);
    if(state.segSz==="Yes")chip("seizure","Seizure watch",FLAG_EMOJIS.seizure);
    if(hasSpecialDiet())chip("diet","Special diet",FLAG_EMOJIS.diet);
    if(clean("iNPO"))chip("red","NPO",FLAG_EMOJIS.npo);
    if(!count){
      var empty=document.createElement("span");
      empty.className="cc-alert-empty";
      empty.textContent="No positive safety or nursing alerts selected.";
      wrap.appendChild(empty);
    }
  }
  function render(){
    text("pClinic",clean("iClinic")||"ASK A VET™ Hospital");
    var date=displayDate(clean("iDate"));
    var day=clean("iDay");
    var dateDay=date;
    if(day)dateDay=date==="—"?"Day "+day:date+" · Day "+day;
    text("pDate",dateDay);
    text("pDept",clean("iDept"));
    text("pName",clean("iName")||"PATIENT NAME");
    text("pPatientNo",clean("iPatientNo"));
    text("pClient",clean("iClient"));
    text("pDr",clean("iDr"));
    var behaviourBox=$("pBehaviour");
    behaviourBox.className="behaviour-box";
    behaviourBox.innerHTML="";
    var behaviourSmall=document.createElement("span");
    behaviourSmall.className="small";
    behaviourSmall.textContent="Patient behaviour";
    var behaviourBig=document.createElement("span");
    behaviourBig.className="big";
    var behaviourEmoji=document.createElement("span");
    behaviourEmoji.className="behaviour-emoji";
    behaviourEmoji.setAttribute("aria-hidden","true");
    behaviourEmoji.textContent=BEHAVIOUR_EMOJIS[state.segBeh]||"🐾";
    var behaviourText=document.createElement("span");
    behaviourText.textContent=state.segBeh||"NOT SET";
    behaviourBig.appendChild(behaviourEmoji);
    behaviourBig.appendChild(behaviourText);
    behaviourBox.appendChild(behaviourSmall);
    behaviourBox.appendChild(behaviourBig);
    if(state.segBeh==="Calm")behaviourBox.classList.add("calm");
    else if(state.segBeh==="Anxious")behaviourBox.classList.add("anxious");
    else if(state.segBeh==="Aggressive")behaviourBox.classList.add("aggressive");
    text("pUpdated",clean("iUpdated"));
    text("pReason",clean("iReason"));
    text("pDiet",clean("iDietText")||(hasSpecialDiet()?"SPECIAL DIET: instructions not entered":"—"));
    text("pNpo",clean("iNPO"));
    text("pNotes",clean("iNotes"));

    var demo=[];
    demo.push(state.segSpecies==="cat"?"Cat":"Dog");
    if(clean("iSex"))demo.push(clean("iSex"));
    if(state.segDesexed)demo.push(state.segDesexed==="Yes"?"Desexed":"Entire");
    if(clean("iAge"))demo.push(clean("iAge"));
    if(getWeightKg())demo.push(weightText());
    $("pDemo").textContent=demo.join(" · ");

    var calc="";
    if(getWeightKg()){
      calc=weightText();
      if($("showRer").checked)calc+="\nRER: "+fmt(rerValue())+" kcal/day";
    }
    text("pCalc",calc);

    var code=$("pCode");
    code.className="code-box";
    code.innerHTML="";
    var small=document.createElement("span");
    small.className="small";
    small.textContent="Code status";
    var big=document.createElement("span");
    big.className="big";
    big.textContent=state.segCode||"NOT SET";
    code.appendChild(small);
    code.appendChild(big);
    if(state.segCode==="CPR")code.classList.add("cpr");
    if(state.segCode==="DNR")code.classList.add("dnr");

    renderAlerts();
    renderWeight();
    var coreResult=validate(false,false);
    updatePrintFitHint(coreResult);
  }
  function measurePrintFit(size){
    var spec=PRINT_SPECS[size]||PRINT_SPECS.a5l;
    var holder=document.createElement("div");
    var wasPrintInvalid=root.classList.contains("print-invalid");
    var actual=0;
    holder.className="print-fit-probe measuring";
    holder.setAttribute("data-size",size);
    holder.style.width=((spec.widthMm-(2*spec.marginMm))*MM_TO_PX)+"px";
    var clone=$("cageCard").cloneNode(true);
    clone.removeAttribute("id");
    Array.prototype.forEach.call(clone.querySelectorAll("[id]"),function(el){el.removeAttribute("id")});
    var cloneBlocker=clone.querySelector(".print-blocker");
    if(cloneBlocker)cloneBlocker.style.display="none";
    holder.appendChild(clone);
    /* The print-invalid layout hides card content. Temporarily remove that class so
       repeated beforeprint events still measure the complete cage card. */
    if(wasPrintInvalid)root.classList.remove("print-invalid");
    try{
      root.appendChild(holder);
      actual=Math.ceil(clone.getBoundingClientRect().height);
    }finally{
      if(holder.parentNode)holder.parentNode.removeChild(holder);
      if(wasPrintInvalid)root.classList.add("print-invalid");
    }
    var available=(spec.heightMm-(2*spec.marginMm))*MM_TO_PX;
    var safeAvailable=available-(2*MM_TO_PX);
    return {ok:actual<=safeAvailable,actualPx:actual,availablePx:available,safeAvailablePx:safeAvailable,label:spec.label};
  }
  function updatePrintFitHint(coreResult){
    var hint=$("printFitHint");
    if(!hint)return;
    hint.className="helper";
    if(!coreResult||!coreResult.ok){
      hint.textContent="Complete the required patient details to check the one-page print fit.";
      return;
    }
    var fit=measurePrintFit($("printSize").value);
    if(fit.ok){
      hint.className="helper fit-ok";
      hint.textContent="Fits on one "+fit.label+" page.";
    }else{
      hint.className="helper fit-error";
      hint.textContent="Too much content for one "+fit.label+" page. Choose a larger card size or shorten the instructions.";
    }
  }
  function validate(showMessage,checkPrintFit){
    var errors=[];
    var fitIssue=null;
    if(!clean("iName"))errors.push("Enter the patient name.");
    if(!clean("iPatientNo"))errors.push("Enter the patient number.");
    if(state.segCode!=="CPR"&&state.segCode!=="DNR")errors.push("Select CPR or DNR.");
    if(hasWeightEntry()&&!getWeightKg())errors.push("Enter a body weight greater than zero, or clear the weight field.");
    if(state.segInf==="Yes"&&(state.segBarrier===null||state.segBarrier==="None"))errors.push("Set a barrier nursing level for the infectious patient.");
    if(checkPrintFit&&!errors.length){
      fitIssue=measurePrintFit($("printSize").value);
      if(!fitIssue.ok)errors.push("This card is too long for one "+fitIssue.label+" page. Choose a larger card size or shorten the instructions.");
    }
    var invalid=errors.length>0;
    $("printBlocker").style.display=invalid?"block":"none";
    $("printBlocker").textContent=invalid?(fitIssue&&!fitIssue.ok?"Print blocked: ":"Do not use: ")+errors.join(" "):"";
    if(showMessage){
      if(invalid)setNotice("red",errors[0]);
      else setNotice("green",checkPrintFit?"Cage card is ready to print.":"Cage card is ready.");
    }
    return {ok:!invalid,errors:errors,fitIssue:fitIssue};
  }
  function focusFirstInvalid(result){
    var first=result.errors[0]||"";
    if(first.indexOf("patient name")!==-1)$("iName").focus();
    else if(first.indexOf("patient number")!==-1)$("iPatientNo").focus();
    else if(first.indexOf("CPR or DNR")!==-1)$("segCode").querySelector("button").focus();
    else if(first.indexOf("body weight")!==-1)$("iWeight").focus();
    else if(first.indexOf("barrier nursing")!==-1)$("segBarrier").querySelector("button").focus();
    else if(first.indexOf("too long")!==-1)$("printSize").focus();
  }
  function updatePageSize(){
    var size=$("printSize").value;
    root.setAttribute("data-print-size",size);
    var rule=size==="a4p"?"@page{size:A4 portrait;margin:9mm}":size==="a4l"?"@page{size:A4 landscape;margin:9mm}":"@page{size:A5 landscape;margin:7mm}";
    var pageStyle=root.querySelector("[data-aav-page-style]");
    if(pageStyle)pageStyle.textContent=rule;
  }
  function armPrintCleanup(){
    if(printCleanupTimer)clearTimeout(printCleanupTimer);
    /* afterprint, print-media changes and window focus normally restore the page.
       This is only a failsafe for browsers that emit none of those signals. */
    printCleanupTimer=setTimeout(finishPrint,300000);
  }
  function preparePrint(){
    updatePageSize();
    render();
    var result=validate(false,true);
    root.classList.toggle("print-invalid",!result.ok);
    if(root.parentNode!==document.body&&!printMarker){
      printMarker=document.createComment("aav-cage-card-print-position");
      root.parentNode.insertBefore(printMarker,root);
      document.body.appendChild(root);
    }
    document.body.classList.add("aav-cage-card-printing");
    printRestorePending=true;
    armPrintCleanup();
  }
  function finishPrint(){
    if(printCleanupTimer){clearTimeout(printCleanupTimer);printCleanupTimer=null;}
    document.body.classList.remove("aav-cage-card-printing");
    root.classList.remove("print-invalid");
    if(printMarker&&printMarker.parentNode){
      printMarker.parentNode.insertBefore(root,printMarker);
      printMarker.parentNode.removeChild(printMarker);
    }
    printMarker=null;
    printRestorePending=false;
  }
  function requestPrint(){
    updatePageSize();
    render();
    var result=validate(true,true);
    if(!result.ok){focusFirstInvalid(result);return;}
    preparePrint();
    window.print();
  }
  function summaryText(){
    var lines=[];
    lines.push("VETERINARY HOSPITAL CAGE CARD");
    lines.push("Clinic / hospital: "+(clean("iClinic")||"ASK A VET(TM) Hospital"));
    lines.push("Date: "+(displayDate(clean("iDate"))||"-")+(clean("iDay")?" | Day "+clean("iDay"):"")+" | Location: "+(clean("iDept")||"-"));
    lines.push("Patient: "+(clean("iName")||"-")+" | Patient no: "+(clean("iPatientNo")||"-")+" | Client no: "+(clean("iClient")||"-"));
    var reproductive=state.segDesexed==="Yes"?"Desexed":state.segDesexed==="No"?"Entire":"-";
    lines.push("Species: "+(state.segSpecies==="cat"?"Cat":"Dog")+" | Sex: "+(clean("iSex")||"-")+" | Reproductive status: "+reproductive+" | Age: "+(clean("iAge")||"-")+" | Weight: "+weightText());
    if(getWeightKg()&&$("showRer").checked)lines.push("RER: "+fmt(rerValue())+" kcal/day");
    lines.push("Code status: "+(state.segCode||"NOT SET")+" | Behaviour: "+(state.segBeh||"-")+" | Dr in charge: "+(clean("iDr")||"-"));
    if(clean("iReason"))lines.push("Reason for hospitalisation: "+clean("iReason"));
    var flags=[];
    if(state.segBarrier&&state.segBarrier!=="None")flags.push("Barrier nursing: "+state.segBarrier);
    if(state.segImm==="Yes")flags.push("Immunocompromised");
    if(state.segInf==="Yes")flags.push("INFECTIOUS");
    if(state.segChemo==="Yes")flags.push("CYTOTOXIC");
    if(state.segSz==="Yes")flags.push("Seizure watch");
    if(hasSpecialDiet())flags.push("Special diet");
    if(clean("iNPO"))flags.push("NPO");
    lines.push("Safety / nursing flags: "+(flags.length?flags.join(", "):"none selected"));
    if(clean("iDietText"))lines.push("Dietary requirements: "+clean("iDietText"));
    if(clean("iNPO"))lines.push("NPO information: "+clean("iNPO"));
    if(clean("iNotes"))lines.push("Essential cage notes: "+clean("iNotes"));
    if(clean("iUpdated"))lines.push("Card updated: "+clean("iUpdated"));
    lines.push("ASK A VET(TM) Hospital Cage Card Generator");
    return lines.join("\n");
  }
  function copySummary(){
    var result=validate(true,false);
    if(!result.ok){focusFirstInvalid(result);return;}
    var value=summaryText();
    function ok(){setNotice("green","Cage card summary copied to the clipboard.")}
    function fallback(){
      var ta=document.createElement("textarea");
      ta.value=value;
      ta.style.position="fixed";
      ta.style.opacity="0";
      document.body.appendChild(ta);
      ta.select();
      var copied=false;
      try{copied=document.execCommand("copy")}catch(ignore){}
      document.body.removeChild(ta);
      if(copied)ok();else setNotice("amber","Clipboard access was blocked. Select the preview information and copy it manually.");
    }
    if(navigator.clipboard&&navigator.clipboard.writeText)navigator.clipboard.writeText(value).then(ok,fallback);
    else fallback();
  }
  function clearCard(){
    if(!window.confirm("Clear all patient and cage-card information?"))return;
    root.querySelectorAll("input[type='text'],input[type='number'],textarea").forEach(function(el){el.value=""});
    $("iDate").value=todayValue();
    $("iSex").value="";
    $("printSize").value="a5l";
    $("showRer").checked=true;
    resetSegment("segSpecies","dog");
    resetSegment("segDesexed",null);
    resetSegment("segWU","kg");
    resetSegment("segCode",null);
    resetSegment("segBeh",null);
    resetSegment("segBarrier",null);
    resetSegment("segImm",null);
    resetSegment("segInf",null);
    resetSegment("segChemo",null);
    resetSegment("segSz",null);
    resetSegment("segDiet",null);
    currentWeightUnit="kg";
    $("iWeight").placeholder="kg";
    updatePageSize();
    setNotice("green","Cage card cleared.");
    render();
    $("iName").focus();
  }

  initSegment("segSpecies");
  initSegment("segDesexed",{allowClear:true});
  initSegment("segCode");
  initSegment("segBeh",{allowClear:true});
  initSegment("segBarrier",{allowClear:true});
  initSegment("segImm",{allowClear:true});
  initSegment("segInf",{allowClear:true});
  initSegment("segChemo",{allowClear:true});
  initSegment("segSz",{allowClear:true});
  initSegment("segDiet",{
    allowClear:true,
    change:function(next){
      if(clean("iDietText")&&next!=="Yes"){
        resetSegment("segDiet","Yes");
        setNotice("amber","Dietary instructions are entered, so Special diet remains set to Yes. Clear the instructions first if no special diet is required.");
      }
    }
  });
  initSegment("segWU",{
    change:function(next){
      if(next===currentWeightUnit)return;
      var raw=Number($("iWeight").value);
      if(isFinite(raw)&&raw>0){
        $("iWeight").value=(next==="lb"?raw*LB_PER_KG:raw/LB_PER_KG).toFixed(2);
      }
      currentWeightUnit=next;
      $("iWeight").placeholder=next;
    }
  });

  $("cageForm").addEventListener("submit",function(event){event.preventDefault()});
  $("iDietText").addEventListener("input",function(){
    if(clean("iDietText")&&state.segDiet!=="Yes")resetSegment("segDiet","Yes");
  });

  function clearTransientNotice(){
    var box=$("formNotice");
    if(box.classList.contains("show"))setNotice("","");
  }
  function handleFieldUpdate(){
    clearTransientNotice();
    render();
  }
  root.querySelectorAll("input,select,textarea").forEach(function(el){
    if(el.id==="printSize")return;
    el.addEventListener("input",handleFieldUpdate);
    el.addEventListener("change",handleFieldUpdate);
  });
  $("printSize").addEventListener("change",function(){
    clearTransientNotice();
    updatePageSize();
    updatePrintFitHint(validate(false,false));
  });
  $("printBtn").addEventListener("click",requestPrint);
  $("copyBtn").addEventListener("click",copySummary);
  $("clearBtn").addEventListener("click",clearCard);
  window.addEventListener("beforeprint",preparePrint);
  window.addEventListener("afterprint",finishPrint);
  if(window.matchMedia){
    printMediaQuery=window.matchMedia("print");
    var handlePrintMediaChange=function(event){
      if(event.matches)preparePrint();
      else if(printRestorePending)finishPrint();
    };
    if(printMediaQuery.addEventListener)printMediaQuery.addEventListener("change",handlePrintMediaChange);
    else if(printMediaQuery.addListener)printMediaQuery.addListener(handlePrintMediaChange);
  }
  window.addEventListener("focus",function(){
    if(printRestorePending&&(!printMediaQuery||!printMediaQuery.matches)){
      setTimeout(function(){
        if(printRestorePending&&(!printMediaQuery||!printMediaQuery.matches))finishPrint();
      },100);
    }
  });

  $("iDate").value=todayValue();
  updatePageSize();
  render();

    }
  }

  customElements.define(ELEMENT_NAME, HospitalCageCardGenerator);
})();
